import PropTypes from "prop-types";
import { Box, ListItem, ListItemText, Typography } from "@mui/material";
import { CustomTypography } from "./inputs";

export const PropertyListItem = (props) => {
  const { align, children, disableGutters, value, label, ...other } = props;

  return (
    <ListItem
      sx={{
        px: disableGutters ? 0 : 3,
        py: 1.5,
      }}
      {...other}
    >
      <ListItemText
        primary={
          <Typography
            sx={{
              minWidth: align === "vertical" ? "inherit" : 180,
              fontFamily: "tmwCustomFont",
              textTransform: "uppercase",
              letterSpacing: 2,
              fontSize: props?.title ? 14 : 11,
              fontWeight: props?.title ? "600" : "300",
              paddingTop: "4px",
            }}
            variant="body2"
          >
            {label}
          </Typography>
        }
        secondary={
          <Box>
            {children || (
              <CustomTypography message={value} color="text.secondary" />
            )}
          </Box>
        }
        sx={{
          display: "flex",
          flexDirection: align === "vertical" ? "column" : "row",
          my: 0,
        }}
      />
    </ListItem>
  );
};

PropertyListItem.defaultProps = {
  align: "vertical",
};

PropertyListItem.propTypes = {
  align: PropTypes.oneOf(["horizontal", "vertical"]),
  children: PropTypes.node,
  disableGutters: PropTypes.bool,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
};
